export const THANK_YOU = {
  header: "THANK YOU",
  message:
    "Please allow 2-3 full business days, from the date of signing, for us to process your information. Once your request has been completed, we will send a confirmation email using the contact information you provided.",
  cta: "Continue to HillsPet.com",
}

export const HILLS_PET_URL = "http://hillspet.com/"
